export const selectApp = (state) => state.app;
export const selectAppStep = (state) => selectApp(state).step;
export const selectAppIframe = (state) => selectApp(state).iframe;
export const selectAppLoading = (state) => selectApp(state).loading;
export const selectAppModal = (state) => selectApp(state).modal;
